// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ZB7y0","modal-show":"Modal_modal-show__Z5eLq","openModal":"Modal_openModal__w3MeD","modal-bg-show":"Modal_modal-bg-show__PA0T1"};